import './styles/design-system.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './plugins/axios'

// 确保HLS.js全局可用（VideoStreamPage / ComputerVisionPage 使用 window.Hls）
import Hls from 'hls.js'
if (typeof window !== 'undefined') {
  window.Hls = Hls
}

Vue.config.productionTip = false

// —— 关闭时标记销毁，刷新时取消 ——
// beforeunload：关闭和刷新都触发 → 标记 1 秒后销毁
// App.vue mounted 中发送 keep 取消销毁（刷新场景）；关闭标签页无新页面 → 1 秒后真正销毁
window.addEventListener('beforeunload', function() {
  navigator.sendBeacon('/api/session/destroy');
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// Vue 挂载后立即取消待销毁标记（刷新场景）
fetch('/api/session/keep', { method: 'POST' }).catch(function() {});
